























import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";
import {Notification} from "@/modules/Notification";
import _ from "lodash";
import NotificationRepository from "@/repositories/NotificationRepository";
import Owner from "@/model/cospirit-api/Owner";
import Tag from "@/components/miscellaneous/Tag.vue";
import SelectOwner from "@/components/owner/SelectOwner.vue";
import NotificationDetails from "@/components/admin/notification/NotificationDetails.vue";

const components = {
    Tag,
    SelectOwner,
    NotificationDetails
};

@Component({components})
export default class SocleNotificationList extends Vue {
    @Prop({default: false}) private reload!: boolean;

    private notifications: Notification[] = [];
    private loadingNotification: boolean = false;

    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;
    @Getter("getOwners") public owners!: Owner[];
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;
    @Getter("getOwnerWorkflow") public getOwnerWorkflow!: (isClient: boolean) => { [p: string]: string[] };

    @Watch("reload")
    public onReloadChange(newValue: boolean): void {
        if (newValue) {
            this.getNotifications();
        }
    }

    public mounted(): void {
        this.getNotifications();
    }

    private getNotifications(): void {
        this.loadingNotification = true;
        this.notifications = [];
        const params = {
            filters: {
                ownerUuid: this.ownerUuid,
                module: "socle",
            },
        };
        NotificationRepository.get(params).then((data: object[]) => {
            if (data.length > 0) {
                this.notifications = data as Notification[];
            } else {
                this.notifications = [];
            }
            this.loadingNotification = false;
        });
    }

    private editNotification(notification: Notification | null): void {
        this.$emit("edit-notification", notification);
    }


    private deleteNotification(notificationUuid: string): void {
        this.$confirm(_.invoke(this.$options.filters, "trans", "deleteNotificationConfirmation"))
            .then(() => {
                NotificationRepository.delete({uuid: notificationUuid}).then(() => {
                    this.getNotifications();
                    this.$message({
                        message: _.invoke(this.$options.filters, "trans", "successDeleteNotification"),
                        type: "success"
                    });
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: _.invoke(this.$options.filters, "trans", "cannotDeleteNotification"),
                    });
                });
            }).catch(() => {
                return;
            }
        );
    }
}
